/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { faWelcomeContent } from "./constants";
import Text from "components/ui/Text";
import { Button } from "components/ui/Button";
import Stack from "components/ui/Stack";

interface IFAWelcome {
  setCurrentForm: React.Dispatch<React.SetStateAction<string>>;
}

const FAWelcome: React.FC<IFAWelcome> = ({ setCurrentForm }) => {
  return (
    <form>
      <Stack>
        <Stack>
          <Stack>
            <h3 className="text-white text-xl font-bold">
              Welcome to Two-Factor Authentication Setup
            </h3>

            <Text className="text-base " style={{ color: "#9A9A9A" }}>
              Enhance the security of your account by setting up Two-Factor
              Authentication (2FA). Follow the steps below to get started:
            </Text>
          </Stack>

          <Stack className="mt-8 mb-10 space-y-6">
            {faWelcomeContent.map((item, index) => (
              <div className="flex flex-row gap-x-[15px]" key={index}>
                <Text
                  as="span"
                  className="w-[20px] h-[20px] font-bold rounded-full bg-white text-[#252525] mt-0.5 justify-center items-center inline-flex"
                >
                  {index + 1}
                </Text>

                <Stack className="gap-y-[4px]">
                  <h3 className="text-white text-base font-bold">
                    {item.head}
                  </h3>
                  <Text className="text-sm" style={{ color: "#9A9A9A" }}>
                    {item.description}
                  </Text>
                </Stack>
              </div>
            ))}
          </Stack>
        </Stack>

        <div>
          <Button
            variant="primary"
            size="xl"
            id="loginBtn"
            onClick={() => setCurrentForm("qr_code")}
          >
            Get Started
          </Button>
        </div>
      </Stack>
    </form>
  );
};

export default FAWelcome;
